// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"UIUXDesignLp2_LPPage__3M_Om"};